import React from 'react'
import Dialog from '@material-ui/core/Dialog'

import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useMutation } from '@apollo/client'

import { MD_ENV } from 'graphql/mutations'
import styles from '../environment.module.scss'
import { transpileModule } from 'typescript'

const DeleteEnvironment = ({ open, setOpen, env, update, loading }) => {
  const [call] = useMutation(MD_ENV)

  const deleteEnvironment = id => {
    loading(true)
    setOpen(false)
    call({ variables: { id } })
      .then(() => {
        update()
      })
      .catch(err => console.error(err))
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Confirmation Dialog
            </Typography>
            <Typography variant="h5" component="h2"></Typography>
            <Typography variant="body2" component="p">
              Press the confirmation button to delete {env.name} environment
              file
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              size="small"
              className={styles.btn}
              onClick={() => deleteEnvironment(env.id)}
            >
              Confirm delete {env.name}
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </div>
  )
}

export default DeleteEnvironment
